import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';
import StoreService from 'scaleflow/services/store';

class SettingsRolesListRoute extends Route {
  @service declare store: StoreService;

  model() {
    return this.store.findAll('role');
  }
}

export default instrumentRoutePerformance(SettingsRolesListRoute);
